<template>
<div class="exchange_body">

  <div class="dizhi">
    <div @click="showList=true">添加收货地址</div>
  </div>


  <div style="width: 90%;margin: auto;height:70px;font-size: 14px;" v-if="items!=''">
    <div style="margin-top: 5px;">收货人：{{items.name}}</div>
    <div style="margin-top: 5px;">电话：{{items.tel}}</div>
    <div style="margin-top: 5px;">地址：{{items.address}}</div>
<!--    <div style="font-size: 14px;">{{items.name}}<span>{{items.tel}}</span></div>-->
<!--    <div style="margin-top: 10px;">{{items.address}}</div>-->
  </div>

  <div class="beij"></div>

  <div class="xiangqing">
    <div class="tupian"><img :src="lists.covermap" ></div>
    <div class="wenzi">
      <div class="shangp" >{{lists.titles}}</div>
      <div class="jifen" >{{lists.integral}}积分</div>
    </div>
  </div>

  <div class="beij clear" style="margin-top: 20px;"></div>

  <van-cell-group>
    <van-cell title="配送方式" value="快递免邮" />
    <van-cell title="使用积分" :value="lists.integral"  />
  </van-cell-group>

  <van-submit-bar
    button-text="提交订单"
    @submit="onSubmit"
  />

  <van-popup
    v-model="showList"
    round
    position="bottom"
    style="height: 90%; padding-top: 4px;"
  >

  <van-address-list
    v-model="chosenAddressId"
    :list="list"
    disabled-text="以下地址超出配送范围"
    default-tag-text="默认"
    @add="onAdd"
    @edit="onEdit"
    @click-item="guanbi"
  />
  </van-popup>

</div>
</template>

<script>
    import { Toast } from 'vant';
    import { Dialog } from 'vant';
    export default {
        name: "exchange",
        data(){
          return{
              chosenAddressId:'1',
              showList:false,
              chosenAddressId:1,
              list: [],
              lists:{},
              ids:'',
              items:''
          }
        },
        created() {
            this.getdata()
            this.getcity()
        },
        methods:{
            guanbi(item,index){
                console.log(item.id,2313)
                this.ids=item.id
                this.items=item
                this.showList=false
            },
            getdata() {
                this.myrequest({
                    url:'/client/getaddresslist.action',
                    types:'get',
                    data:{

                    },
                    succ: (res) => {
                        this.list=res.data
                    },
                    errs: (msg) => {

                    }
                })
            },
            getcity() {
                this.myrequest({
                    url:'/client/getcommodityinfo.action',
                    types:'get',
                    data:{
                        id: this.$route.query.id
                    },
                    succ: (res) => {
                        this.lists=res.data
                    },
                    errs: (msg) => {

                    }
                })
            },
            onAdd() {
                this.$router.push({ path:'/address'})
            },
            onEdit(item, index) {
                console.log(item,2313)
                // this.$router.push({ path:'/address',query:{id:this.list[index].id}})
                // Toast('编辑地址:' + index);
            },
            onSubmit(){
                Dialog.confirm({
                    title: '兑换',
                    message: '您确定要兑换嘛',
                })
                    .then(() => {
                        this.myrequest({
                            url:'/client/addcommodityorder.action',
                            types:'post',
                            data:{
                                id: this.$route.query.id,
                                aid:this.ids
                            },
                            succ: (res) => {
                                Toast.success('兑换成功');
                                this.$router.go(-1)
                            },
                            errs: (msg) => {
                                Toast.fail(msg);
                            }
                        })
                    })
                    .catch(() => {

                    });

            },

        }
    }
</script>

<style scoped lang="stylus">
  .exchange_body{
    width 100%;
    .clear {
      clear: both;
    }
    >>>.van-popup--bottom.van-popup--round{
      height 75% !important
    }
    .xiangqing{
      width 90%;
      margin 10px auto;
      .tupian{
        float left;
        margin-bottom 5px;
        img{
          width 130px;
          height 100px;
          border-radius 10px ;
        }
      }
      .wenzi{
        float left
        .shangp{
          color: #000;
          margin-left 10px;
          margin-top 10px;
          font-size 14px;
          /*font-weight 500*/
        }
        .jifen{
          color: rgba(255,31,46,0.44)
          margin-left 10px;
          margin-top 10px;
          font-size 14px;
        }
      }

    }
    .dizhi{
      width 100%;
      div{
        width 90px;
        height 20px;
        text-align center
        border 1px solid #39a9ed
        border-radius 10px;
        color #39a9ed
        margin auto
        margin-top 10%;
      }
    }
    .beij{
      background-color #fafafa;
      width 100%;
      height 3px;
      margin-top 3%
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Shopping/exchange.vue